import Request from '../Request';
import EndPoints from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param email
 * @param password
 * @return {Promise<any>|Promise}
 */
export default (function (email, password) {
    var params = { email: email, password: password };
    var request = new Request({
        method: Methods.POST,
        url: EndPoints.LOGIN,
        withCredentials: false,
        headers: null,
        data: params
    });
    return request.execute();
});
